import { defaultFormState } from '@/presentation/components/models';
import { atom } from 'recoil';
export const manageIndividualClassAtom = atom({
    key: 'manageIndividualClass',
    default: {
        students: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        isTableLoading: false,
        isLoading: false,
        reloadStudents: false,
        filters: { input: '', selectedGradeId: null, deleted: false, selectedClassId: '0' },
        dataNotFound: false,
        checked: false,
        assignedTeacher: null,
        classGrade: null,
        teachers: [],
        reloadClass: false,
        modalAddStudent: false,
        class: null,
        isEditClassModalVisible: false,
        reoladClassData: false,
        modalCheckout: false,
        allStudents: []
    }
});
export const modalAddStudentAtom = atom({
    key: 'modalAddStudentAtom',
    default: Object.assign(Object.assign({}, defaultFormState), { firstName: '', lastName: '', email: '', firstNameError: '', lastNameError: '', emailError: '' })
});
